import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { ILogin, IPermissionProps } from "../../models/Login";
import { InputText } from "primereact/inputtext";
import { Search } from "../../shared/Search";
import { IModel } from "./SkillTeamManagement";
import { EmptyTeam } from "./EmptySkillTeam";
import { ITeamSkillMast } from "../../models/ISkillTeamManagement";
import { SkillCategoryTable } from "./SkillCategoryTable";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { EmptySkillFilter, Filter, ISkillFilter } from "./Filter";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Toast } from "primereact/toast";
import { AllocationBranch } from "./AllocationBranch";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
    setModal2: (modal: {
        open: boolean,
        singleData: ITeamSkillMast
    }) => void,
}

export interface ITeamMast {
    branch?: string,
    company?: string,
    team_ID?: number,
    team_Manager?: string,
    team_Name?: string,
}

export interface RowData {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    createdOn?: Date,
    status?: boolean,
    team_ID?: number,
    team_Manager?: string,
    teamManagerid?: number,
    team_Name?: string,
    user_Added_by?: number,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITeamSkillMast>, loading: boolean });
    const [defaultTableData, setDefaultTableData] = useState({ tableData: [] } as { tableData: Array<ITeamSkillMast> });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [skillsCategoryTable, setSkillCategoryTable] = useState({ singledata: {}, open: false } as { singledata: any, open: boolean });
    const [skillFilter, setSkillFilter] = useState<ISkillFilter>(EmptySkillFilter);
    const [showSetBranch, setShowSetBranch] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITeamSkillMast });
    const dt = useRef<any>(null);
    const toast = useRef(null);
    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyTeam, teamNameList: defaultTableData.tableData });
    };
    
    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });
    
    const openEdit = (rowData: ITeamSkillMast) => {
        let data: any = {
            team_ID: rowData.team_ID,
            team_Name: rowData.team_Name,
            status: rowData.status,
            company_ID: rowData.company_ID,
            branch_ID: rowData.branch_ID,
            teamManagerid: rowData.teamManagerid,
            createdOn: rowData.createdOn,
            user_Added_by: rowData.user_Added_by,
            allocate_Users: rowData.allocate_Users,
            allocate_For_Same_Branch: rowData.allocate_For_Same_Branch,

        };

        props.setModal({ open: true, singleData: data, teamNameList: defaultTableData.tableData });
    };

    const getTableDataCount = async () => {
        const response = await Fetch("Team_Skill_Mast/count", "GET", null, null, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    // const onPage = (event: any) => {
    //     delete event.filters;
    //     delete event.multiSortMeta;
    //     setLazyParams(event);
    // }

    const leftToolbarTemplate = () => {
        return (
            props.permissions.is_Create ?
                <React.Fragment>
                    <div className="my-2">
                        <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    </div>
                </React.Fragment> : ''
        );
    };

    const rightToolbarTemplate = () => {
        //     <React.Fragment>
        //         <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
        //     </React.Fragment> : ''
        return (

            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Skill Team Management</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText placeholder="Search By Team Name" onChange={(e) => {
                    let data = defaultTableData.tableData.filter(el => el.team_Name?.toLowerCase().includes(e.target.value.toLowerCase()));
                    setTableData({ tableData: data, loading: false });
                }} />
            </span>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Skill_Mast", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(skillFilter)}`, props.toast);
        if (response) {
            const data: Array<ITeamMast> = await response.json();
            setTableData({ tableData: data, loading: false });
            setDefaultTableData({ tableData: data });
        }
    }

    const RemoveTeam = async (rowData: ITeamSkillMast) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Skill_Mast", "DELETE", null, `team_ID=${rowData.team_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: " Skill Team Removed", life: 3000 });
            loadTableData();
        }
    }
    const hideTable = () => {
        setSkillCategoryTable({ singledata: {}, open: false });
    }
    const openCategoryTable = (rowDatauser: any) => {
        setSkillCategoryTable({ singledata: rowDatauser, open: true });
    }

    const rejectFunc = () => {
        props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 })

    }

    const confirmDelete = (rowData: ITeamSkillMast) => {
        confirmDialog({
            message: `Are you sure you want to delete this team`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            // defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept: () => RemoveTeam(rowData),
            reject: () => rejectFunc()
        });
    }


    const action = (rowData: ITeamSkillMast) => {
        return (
            <div className="flex gap-3">
                {props.permissions.is_Update && <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>}
                { <Button className="pi pi-users text-primary bg-white border-none" onClick={() => props.setModal2({ open: true, singleData: rowData })}></Button>}
                {/* {props.permissions.is_Delete && <Button className="pi pi-trash text-primary bg-white border-none" onClick={() => RemoveTeam(rowData)}></Button>} */}
                {/* {_roles.includes(1) && <Button icon="pi pi-external-link" className="p-button-rounded text-primary bg-white border-none" onClick={() => openCategoryTable(rowData)} />} */}
                {props.permissions.is_Delete && <Button className="pi pi-trash border-none" onClick={() => { confirmDelete(rowData) }} style={{ backgroundColor: 'white', borderColor: 'red', color: 'red' }} ></Button>}
                {rowData.allocate_For_Same_Branch == true && _roles.includes(1) && <Button icon="pi pi-sitemap" className="p-button-rounded text-primary bg-white border-none" onClick={() => setShowSetBranch({ open: true, singleData: rowData })} />}

            </div>
        );
    }

    useEffect(() => {
        if (lazyParams.rows) {
            getTableDataCount();
            loadTableData();
        } else {
            loadTableData();
        }
    }, [lazyParams, props.reload, skillFilter]);

    useEffect(() => {
        getTableDataCount();
    }, []);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter skillFilter={skillFilter} setSkillFilter={(skillFilter: ISkillFilter) => setSkillFilter(skillFilter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="team_Name" header="Team Name" />
                <Column field="company" header="Company" />
                <Column field="branch" header="Branch" />
                <Column field="team_Manager" header="Team Manager" />
                <Column field="" header="Action" body={action} />
            </DataTable>
            <Toast ref={toast} />
            <ConfirmDialog />

            <SkillCategoryTable permissions={props.permissions} open={skillsCategoryTable.open} hideHistory={hideTable} singledata={skillsCategoryTable.singledata} toast={props.toast} />
            <AllocationBranch open={showSetBranch.open} singleData={showSetBranch.singleData} hideDialog={() => { setShowSetBranch({ open: false, singleData: {} }); }} toast={props.toast} />
        </>
    );
}